import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-visa': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M470.1 231.3c0 0 7.6 37.2 9.3 45h-33.4c3.3-8.9 16-43.5 16-43.5-0.2 0.3 3.3-9.1 5.3-14.9zM576 80v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2l63.2-155.2h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1h-64.7l-0.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zM246.9 331.4l25.2-155.4h-40.2l-25.1 155.4h40.1zM386.8 280.6c0.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2 0.2-6.6 7.3-13.4 23.1-13.4 13.1-0.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-0.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-0.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2 0.1 69.7-20.8 70-53zM528 331.4l-32.4-155.4h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5h42.2s6.9-19.2 8.4-23.3h51.6c1.2 5.5 4.8 23.3 4.8 23.3h37.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-visa.js
// module id = 752
// module chunks = 0